module.exports = __webpack_public_path__ + "img/rocketry.4fd5280c.png";